import { RequestNewVersion } from '../../../../../classes/RequestNewVersion';

export const getAllPartsListRequest = async () => {
  const request = new RequestNewVersion(
    `${process.env.REACT_APP_URL_API_LARAVEL}/partyType/get_all`,
    'get',
    null,
    {}
  );

  const partsListResponse = await request.executeRequest();
  if (
    typeof partsListResponse === 'object' &&
    Number(partsListResponse.code) === 200 &&
    typeof partsListResponse.response === 'object' &&
    Array.isArray(partsListResponse.response.partyTypes)
  ) {
    return partsListResponse.response.partyTypes;
  }
  return [];
};
